import { useRef } from 'react'

import { Box, AvatarStack as DSAvatarStack } from '@factorialco/deprecated-design-system'
import { AvatarStackItemFragment } from 'generated/resources/graphql'
import { useResizeObserver } from 'usehooks-ts'

import buildUrl from 'modules/core/lib/buildUrl'

const AVATAR_WIDTH = 40
const AVATAR_OVERLAP = 12

interface Props {
  accesses?: AvatarStackItemFragment[]
  totalCount?: number
}

// We use this wrapper around the design-system AvatarStack component
// to make it responsive. It will calculate the width of the parent container
// and calculate how many avatars it can fit, the rest will be hidden.
export function AvatarStack({ accesses = [], totalCount = 0 }: Props) {
  const boxRef = useRef<HTMLDivElement>(null)
  const { width = 0 } = useResizeObserver({ ref: boxRef })
  const spacesForAvatars = Math.floor(width / (AVATAR_WIDTH - AVATAR_OVERLAP / 2)) - 1
  const displayedAccesses = accesses
    .slice(0, spacesForAvatars)
    .map((access) => ({ label: access.fullName, url: buildUrl(access.avatar ?? '') }))
  const remainingCount = totalCount - displayedAccesses.length

  return (
    <Box ref={boxRef} flexDirection="row" flexWrap="wrap" position="relative" gap="s4" width="full">
      <DSAvatarStack
        size={`s${AVATAR_WIDTH}`}
        overlap={`s${AVATAR_OVERLAP}`}
        avatars={displayedAccesses}
        leftover={remainingCount}
        textSize="200"
        textColor="grey800"
        backgroundColor="grey200"
      />
    </Box>
  )
}
